var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5566 15.5C27.2221 15.5 28.4998 16.9448 28.5 18.6387V23.3594L28.4863 23.6748C28.3443 25.2368 27.1161 26.5 25.5566 26.5H15.4434C13.7779 26.5 12.5002 25.0552 12.5 23.3613V18.6387C12.5002 16.9374 13.7848 15.5 15.4434 15.5H25.5566ZM19.918 18.1719C19.5183 17.9221 19 18.2094 19 18.6807V23.3193C19 23.7906 19.5183 24.0779 19.918 23.8281L23.6289 21.5088C24.0049 21.2738 24.0049 20.7262 23.6289 20.4912L19.918 18.1719Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledYoutube);
export default __webpack_public_path__ + "static/media/filledYoutube.132acc188297d454361e09f67666de6c.svg";
export { ForwardRef as ReactComponent };